import {DataFrame} from 'data-frames/DataFrameTypes';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export async function generateDatasetPreview(query: string): Promise<{dataFrame: DataFrame}> {
  return await TaskRunner.postJSONPromise({url: '/1/api/query-api-preview-async', data: {query}});
}

export async function fetchQueryApiSDL(schemaNamesFilter?: Array<string>): Promise<string> {
  const data: {schemaNamesFilter?: Array<string>} = {};
  if (schemaNamesFilter) {
    data.schemaNamesFilter = schemaNamesFilter;
  }
  return await TaskRunner.postJSONPromise({url: '/1/api/query-api-sdl-async', data});
}

export async function fetchQueryApiBacklinks(typeName: string): Promise<{typeExtension: string | null}> {
  return await net.postJSONPromise({
    url: '/1/api/query-api-backlink-type-extension',
    data: {typeIdentifier: typeName},
  });
}
